import { render, staticRenderFns } from "./CDRQDocumentList.vue?vue&type=template&id=3d1c1a19&scoped=true&"
import script from "./CDRQDocumentList.vue?vue&type=script&lang=ts&"
export * from "./CDRQDocumentList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1c1a19",
  null
  
)

export default component.exports